import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import * as echarts from "echarts";
import report from "../../../../apis/admin/report";
import notificationHandler from "../../../atoms/Notification";
import { Button, Empty, Spin, Table } from "antd";
import { LoadingOutlined, DownloadOutlined } from "@ant-design/icons";
import moment from "moment";
const colors = [
	"#4FBAF0",
	"#FE6C6C",
	"#FDB022",
	"#FF5CBE",
	"#FF8F6B",
	"#FFD66B",
	"#61EE99",
	"#4FBAF0",
	"#FE6C6C",
	"#FDB022",
];
const ReportQuestionDetail = () => {
	const { id } = useParams();
	const [loading, setLoading] = useState<boolean>(false);
	const [data, setData] = useState<any>([]);

	const [currentPage] = useState(1);
	const [pageSize] = useState(10);

	const antIcon = (
		<LoadingOutlined style={{ fontSize: 70, position: "fixed" }} spin />
	);

	useEffect(() => {
		setLoading(true);
		report
			.getQuestionStatistics(Number(id))
			.then((res: any) => {
				setData(res.data.data.payload);
			})
			.catch((err: any) => {
				notificationHandler("error", err.response.data.data.msg_content);
			})
			.finally(() => setLoading(false));
	}, []);

	const renderColor = (params: { dataIndex: number }, dataColor: string[]) => {
		const gradientColors = dataColor.map((_, index) => ({
			type: "linear",
			x: 0,
			y: 0,
			x2: 1,
			y2: 1,
			colorStops: [
				{ offset: 0, color: dataColor[index * 2] },
				{ offset: 1, color: dataColor[index * 2 + 1] },
			],
		}));

		return gradientColors[params.dataIndex];
	};
	const displayedIndex = (index: any) =>
		(currentPage - 1) * pageSize + index + 1;

	const handleDownload = (id: number) => {
		setLoading(true);
		report
			.getQuestionStatisticsExcel(id)
			.then((res: any) => {
				const blob = new Blob([res.data]);
				const url = window.URL.createObjectURL(blob);
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", `question_statistics_${id}.xlsx`);
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			})
			.catch((err: any) => {
				notificationHandler("error", "Xuất file exel không thành công");
			})
			.finally(() => {
				setLoading(false);
			});
	};

	const columns = [
		{
			title: "STT",
			dataIndex: "index",
			key: "index",
			render: (_: any, __: any, index: any) => displayedIndex(index),
			width: 60,
		},
		{
			title: "Câu trả lời",
			dataIndex: "value",
			key: "value",
			render: (_: unknown, record: any) => {
				return <span>{record.value}</span>;
			},
		},
		{
			title: "Số lượng lựa chọn",
			dataIndex: "customerChoiceAnswerCount",
			key: "customerChoiceAnswerCount",
			width: 180,
		},
		{
			title: "Tỷ lệ lựa chọn",
			dataIndex: "customerChoiceAnswerRate",
			key: "customerChoiceAnswerRate",
			render: (value: string) => {
				return `${value}%`;
			},
			width: 180,
		},
		// {
		// 	title: "Danh sách người lựa chọn",
		// 	dataIndex: "id",
		// 	key: "id",
		// 	render: (value: number) => {
		// 		return (
		// 			<Button
		// 				onClick={() => handleDownload(value)}
		// 				type="text"
		// 				icon={<DownloadOutlined />}
		// 			></Button>
		// 		);
		// 	},
		// 	width: 220,
		// },
	];

	const columnsAnswer = [
		{
			title: "STT",
			dataIndex: "index",
			key: "index",
			width: 60,
			render: (_: any, __: any, index: any) => displayedIndex(index),
		},
		{
			title: "Mã nhân viên",
			dataIndex: "staffCode",
			key: "staffCode",
			width: 150,
		},
		{
			title: "Tên nhân viên",
			dataIndex: "staffName",
			key: "staffName",
			width: 260,
		},
		{
			title: "Số điện thoại",
			dataIndex: "staffPhone",
			key: "staffPhone",
			width: 200,
		},
		{
			title: "Câu trả lời",
			dataIndex: "answer",
			key: "answer",
			render: (_: unknown, record: any) => {
				return <span>{record.answer}</span>;
			},
		},

		{
			title: "Thời gian cập nhật",
			dataIndex: "createdAt",
			key: "createdAt",
			render: (value: string) => {
				return moment(value).format("DD/MM/YYYY HH:mm:ss");
			},
			width: 180,
		},
	];

	const createOption = (
		total: number,
		data: { value: number; name: string }[],
		colors: string[]
	) => ({
		tooltip: {
			trigger: "item",
			formatter: (params: { name: string; value: unknown; percent: number }) =>
				`${params.name}<br /><span class="font-semibold text-base">${params.value}</span> (${params.percent}%)<br />`,
		},
		textStyle: {
			fontFamily: "FS PFBeauSansPro",
		},
		legend: {
			show: false,
		},
		series: [
			{
				name: "giá trị",
				type: "pie",
				startAngle: 90,
				radius: [100, 180],
				avoidLabelOverlap: false,
				itemStyle: {
					borderRadius: 0,
					color: (params: { dataIndex: number }) => renderColor(params, colors),
				},
				label: {
					show: true,
					position: "center",
					formatter: `{a|${total}}`,
					color: "#454459",
					silent: true,
					rich: {
						a: {
							fontSize: 32,
							fontWeight: "bold",
							lineHeight: 48,
							color: "#454459",
						},
						b: {
							fontSize: 16,
							lineHeight: 32,
							color: "#7d7c8b",
						},
					},
				},
				labelLine: {
					show: false,
				},
				data,
			},
		],
	});
	useEffect(() => {
		const chartDom = document.getElementById("chart-container1");
		const myChart = echarts.init(chartDom);
		let option;

		const dataChart = [
			{ value: data?.customerAnsweredCount, name: "Hoàn thành" },
			{ value: data?.customerUnansweredCount, name: "Chưa thực hiện" },
		];

		const total = data?.customerAnsweredCount + data?.customerUnansweredCount;
		option = createOption(total, dataChart, [
			"rgb(97, 238, 153,1)",
			"rgba(97, 238, 153, 0.8)",
			"rgba(255, 143, 107, 1)",
			"rgba(255, 143, 107, 1)",
		]);

		if (option && typeof option === "object") {
			myChart.setOption(option);
		}
		window.addEventListener("resize", () => {
			myChart.resize();
		});
		return () => {
			console.log("Chart 1 unmounted");
			window.removeEventListener("resize", () => {
				myChart.resize();
			});
			myChart.dispose(); // Hủy bỏ chart khi component bị unmount
		};
	}, [data]);

	useEffect(() => {
		if (data?.type !== 1) return;
		const chartDom = document.getElementById("chart-container2");
		const myChart = echarts.init(chartDom);
		let option;

		const dataChart = data?.answerStatistics.map((item: any) => ({
			value: item.customerChoiceAnswerCount,
			name: item.value,
		}));

		const total = data?.answerStatistics.reduce(
			(acc: number, item: any) => acc + item.customerChoiceAnswerCount,
			0
		);
		option = createOption(total, dataChart, [
			"rgba(79, 186, 240, 1)",
			"rgba(79, 186, 240, 0.8)",
			"rgba(254, 108, 108, 1)",
			"rgba(254, 108, 108, 0.8)",
			"rgba(253, 176, 34, 1)",
			"rgba(253, 176, 34, 0.8)",
			"rgba(255, 92, 190, 1)",
			"rgba(255, 92, 190, 0.8)",
			"rgba(255, 143, 107, 1)",
			"rgba(255, 143, 107, 0.8)",
			"rgba(255, 214, 107, 1)",
			"rgba(255, 214, 107, 0.8)",
			"rgba(97, 238, 153, 1)",
			"rgba(97, 238, 153, 0.8)",
			"rgba(79, 186, 240, 1)",
			"rgba(79, 186, 240, 0.8)",
			"rgba(254, 108, 108, 1)",
			"rgba(254, 108, 108, 0.8)",
			"rgba(253, 176, 34, 1)",
			"rgba(253, 176, 34, 0.8)",
		]);

		if (option && typeof option === "object") {
			myChart.setOption(option);
		}
		window.addEventListener("resize", () => {
			myChart.resize();
		});
		return () => {
			window.removeEventListener("resize", () => {
				myChart.resize();
			});
			myChart.dispose(); // Hủy bỏ chart khi component bị unmount
		};
	}, [data]);

	return (
		<div>
			<Spin indicator={antIcon} spinning={loading} />
			<div className="flex gap-4">
				<div
					className={`flex flex-col justify-between p-4 border rounded-lg border-[#EAEAEA]  ${
						data?.type === 0 ? "w-full" : "w-1/2"
					}`}
				>
					<div className="text-lg font-bold flex-1">
						Tỷ lệ nhân viên trả lời câu hỏi
					</div>

					<div className="px-8 pt-6 flex-auto">
						<div className="flex justify-between">
							<div className="flex items-center">
								<div className="h-2 w-2 bg-[#61EE99] rounded-[1px] mr-2"></div>{" "}
								Hoàn thành
							</div>
							<div>{data?.customerAnsweredCount}</div>
						</div>
						<div className="flex justify-between">
							<div className="flex items-center">
								<div className="h-2 w-2 bg-[#FF8F6B] rounded-[1px] mr-2"></div>{" "}
								Chưa thực hiện
							</div>
							<div>{data?.customerUnansweredCount}</div>
						</div>
					</div>

					<div
						id="chart-container1"
						style={{ width: "100%", height: "440px" }}
					></div>
				</div>
				{data?.type === 1 ? (
					<div className="flex flex-col justify-between p-4 border rounded-lg border-[#EAEAEA] w-1/2">
						<div className="text-lg font-semibold">
							Tỷ lệ câu trả lời được chọn
						</div>
						<div className="px-8 pt-6 flex-auto">
							{data?.answerStatistics
								.slice(0, 10)
								.map((item: any, index: number) => (
									<div
										className="flex justify-between"
										key={item.id || item.value}
									>
										<div className="flex items-center">
											<div
												className="h-2 w-2 rounded-[1px] mr-2"
												style={{ backgroundColor: colors[index] }}
											></div>
											{item.value}
										</div>
										<div>{item?.customerChoiceAnswerCount}</div>
									</div>
								))}
						</div>
						<div
							id="chart-container2"
							style={{ width: "100%", height: "440px" }}
						></div>
					</div>
				) : null}
			</div>

			<div className="flex justify-end my-4">
				<Button
					type="primary"
					className="ml-3 bg-cyan-500 hover:text-cyan-500 hover:bg-white hover:border-cyan-500 border-cyan-500 active:bg-cyan-500 focus:bg-cyan-500 focus:text-white"
					icon={<DownloadOutlined />}
					onClick={() => {
						handleDownload(Number(id));
					}}
				>
					Xuất báo cáo
				</Button>
			</div>

			<Table
				dataSource={data?.type === 1 ? data?.answerStatistics : data?.answers}
				rowKey={(recod) => recod.id}
				columns={data?.type === 1 ? columns : columnsAnswer}
				bordered
				pagination={false}
				locale={{
					emptyText: (
						<Empty
							image={Empty.PRESENTED_IMAGE_DEFAULT}
							description="Không có dữ liệu!"
						/>
					),
				}}
			/>
		</div>
	);
};

export default ReportQuestionDetail;
